import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, LogOut } from "lucide-react";
import { useFitViewport } from "../lib/menus";

// Desktop "Mere ▾" dropdown for secondary nav items + Log ud (position:fixed so the clipped top bar never cuts it off)
export default function NavMore({ items, onLogout, dot }) {
  const { pathname } = useLocation();
  const [pos, setPos] = useState(null);
  const btn = useRef(null);
  const menu = useRef(null);
  const open = !!pos;
  useFitViewport(menu, open);
  useEffect(() => setPos(null), [pathname]);
  useEffect(() => {
    if (!open) return;
    const off = (e) => !btn.current?.contains(e.target) && !menu.current?.contains(e.target) && setPos(null);
    const esc = (e) => e.key === "Escape" && setPos(null);
    const close = () => setPos(null);
    document.addEventListener("mousedown", off);
    window.addEventListener("keydown", esc);
    window.addEventListener("resize", close);
    return () => {
      document.removeEventListener("mousedown", off);
      window.removeEventListener("keydown", esc);
      window.removeEventListener("resize", close);
    };
  }, [open]);
  const toggle = () => {
    if (open) return setPos(null);
    const r = btn.current.getBoundingClientRect();
    setPos({ top: Math.round(r.bottom + 6), right: Math.max(8, Math.round(window.innerWidth - r.right)) });
  };
  const active = items.some((i) => !i.external && pathname.startsWith(i.href));
  return (
    <div className="nav-more">
      <button ref={btn} type="button" className={"nav-more-btn" + (active ? " active" : "")} aria-haspopup="menu" aria-expanded={open} onClick={toggle} data-testid="nav-more">
        Mere <ChevronDown size={15} />
        {dot && <span className="nav-dot" data-testid="nav-more-dot" />}
      </button>
      {open && (
        <div ref={menu} className="nav-more-menu" role="menu" style={pos} data-testid="nav-more-menu">
          {items.map((i) =>
            i.external ? (
              <a key={i.href} href={i.href} target="_blank" rel="noreferrer" role="menuitem" data-testid={`nav-more-${i.id}`}>{i.label}</a>
            ) : (
              <Link key={i.href} to={i.href} role="menuitem" className={pathname.startsWith(i.href) ? "active" : ""} data-testid={`nav-more-${i.id}`}>
                {i.label}
                {i.dot && <span className="nav-dot" />}
              </Link>
            )
          )}
          <div className="nm-sep" />
          <button type="button" role="menuitem" className="nm-logout" onClick={onLogout} data-testid="nav-more-logout">
            <LogOut size={16} /> Log ud
          </button>
        </div>
      )}
    </div>
  );
}
